import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Divider } from '@material-ui/core';
import { ConfirmationDialog } from 'components';
import { Typography } from '@redshelf/redshelf-ui';

const useStyles = makeStyles((theme) => {
  return {
    /* Styles applied to the root element. */
    root: {},
    dialogActions: {
      justifyContent: 'center',
      paddingBottom: theme.spacing(4),
    },
    message: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(3),

      padding: theme.spacing(3),
    },
    messageTitle: {
      fontWeight: theme.typography.fontWeightMedium,
    },
  };
});

const PDFExperienceDialog = ({ isOpen, setIsOpen, ...props }) => {
  const classes = useStyles();

  const handleOnClose = () => {
    setIsOpen(false);
  };

  return (
    <ConfirmationDialog
      className={classes.root}
      confirm={{
        action: handleOnClose,
        label: 'I Understand',
      }}
      dialogActionsProps={{
        classes: { root: classes.dialogActions },
      }}
      fullScreen={false}
      id={'confirmPdfExperienceDialog'}
      isOpen={isOpen}
      labelledById="pdf-formats"
      onClose={handleOnClose}
      shouldShowX={true}
      title="PDF Formats"
      titleComponent="h2"
      {...props}
    >
      <>
        <Divider aria-hidden={true} />
        <div className={classes.message}>
          <Typography className={classes.messageTitle} variant="body1">
            This book is in PDF Format.
          </Typography>
          <Typography variant="body1" id="pdf-formats-description">
            PDF can make highlighting and note-taking on a mobile device
            difficult. We recommend using our desktop eReader for any PDF
            titles.
          </Typography>
        </div>
      </>
    </ConfirmationDialog>
  );
};

PDFExperienceDialog.propTypes = {
  isOpen: PropTypes.bool,
  setIsOpen: PropTypes.func,
};

export default PDFExperienceDialog;
